// API user status values
const USER_STATUS: Readonly<{
    ACTIVE_CANCELLED: string;
    ANONYMOUS: string;
    EX_SUBSCRIBER: string;
    MVPD_AUTHZ: string;
    REGISTERED: string;
    RESELLER: string;
    SUBSCRIBER: string;
    SUSPENDED: string;
}> = Object.freeze({
    ACTIVE_CANCELLED: 'ACTIVE_CANCELLED',
    ANONYMOUS: 'ANONYMOUS',
    EX_SUBSCRIBER: 'EX_SUBSCRIBER',
    MVPD_AUTHZ: 'MVPD_AUTHZ',
    REGISTERED: 'REGISTERED',
    RESELLER: 'RESELLER',
    SUBSCRIBER: 'SUBSCRIBER',
    SUSPENDED: 'SUSPENDED',
});

// User status values that indicate a subscriber
const SUBSCRIBER_STATUSES: readonly string[] = Object.freeze([
    USER_STATUS.SUBSCRIBER,
    USER_STATUS.MVPD_AUTHZ,
]);

export { SUBSCRIBER_STATUSES, USER_STATUS };
